import apiClient from '@/api/index.js'

const state = {
  token: localStorage.getItem('token') || '',
  user: JSON.parse(localStorage.getItem('user')) || null,
  status: ''
}

const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status,
  user: state => state.user,
  currentUser: state => state.user,
  permissions: state => (state.user && state.user.permissions) || [],
  // Evalúa una capacidad de la matriz de permisos (ej: 'costs:view')
  hasPermission: state => capability => ((state.user && state.user.permissions) || []).includes(capability)
}

const actions = {
  login({ commit }, credentials) {
    return new Promise((resolve, reject) => {
      commit('AUTH_REQUEST')
      
      // Siempre usar el backend real - eliminar lógica de usuarios de prueba
      // Convertir email a username si es necesario
      const loginData = {
        username: credentials.email || credentials.username,
        password: credentials.password
      }
      
      apiClient.login(loginData)
      .then(response => {
        const token = response.data.access_token
        const user = response.data.user
        
        // Guardar token y usuario reales del backend
        localStorage.setItem('token', token)
        localStorage.setItem('user', JSON.stringify(user))
        
        commit('AUTH_SUCCESS', { token, user })
        resolve(user)
      })
      .catch(error => {
        commit('AUTH_ERROR')
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        reject(new Error(error.response ? error.response.data.error : error.message))
      })
    })
  },
  
  logout({ commit }) {
    return new Promise(resolve => {
      commit('LOGOUT')
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      resolve()
    })
  },
  
  // Acción para obtener el perfil del usuario actual
  async fetchProfile({ commit }) {
    try {
      const response = await apiClient.get('/auth/profile')
      const user = response.data
      localStorage.setItem('user', JSON.stringify(user))
      commit('SET_USER', user)
      return user
    } catch (error) {
      console.error('Error fetching profile:', error)
      throw error
    }
  }
}

const mutations = {
  AUTH_REQUEST(state) {
    state.status = 'loading'
  },
  AUTH_SUCCESS(state, { token, user }) {
    state.status = 'success'
    state.token = token
    state.user = user
  },
  AUTH_ERROR(state) {
    state.status = 'error'
    state.token = ''
    state.user = null
  },
  LOGOUT(state) {
    state.status = ''
    state.token = ''
    state.user = null
  },
  SET_USER(state, user) {
    state.user = user
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
